import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SoloItem } from 'ui/components';

import './CartItemName.scss';

export default class CartItemName extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		toggleModal: PropTypes.func,
	};

	static defaultProps = {
		toggleModal: () => false,
	};

	getSubtitle() {
		if (this.props.item.is_configurable) {
			let itemPack = '';
			const itemConfigurable = this.props.item.configurations.map((item, i) =>
				<p key={i}>{`(${item.quantity_ordered}) ${item.number}`}</p>
			);
			if (this.props.item.is_pack) {
				itemPack = this.props.item.offerings.map(
					(item, i) =>
						item.is_configurable
							? ''
							: <p key={i}>
									{`(${item.quantity *
										this.props.item.quantity_ordered}) ${item.number}`}
								</p>
				);
			}
			return (
				<div>
					{itemPack}
					{itemConfigurable}
				</div>
			);
		} else if (this.props.item.is_pack) {
			return this.props.item.offerings.map((item, i) =>
				<p key={i}>
					{`(${item.quantity *
						this.props.item.quantity_ordered}) ${item.number}`}
				</p>
			);
		}

		return this.props.item.number;
	}

	render() {
		const { item } = this.props;
		return (
			<div className="CartItemName">
				<SoloItem
					soloItem={item}
					toggleModal={this.props.toggleModal}
					displayOnlyName={true}
				/>
				<div className="CartItemName-subtitle">
					{this.getSubtitle()}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/CartItemName/index.js